import { Box, Button, Chip, Divider, Grid2, Typography } from "@mui/material";
import React, { useState } from "react";
import { ReactComponent as CompletedIcon } from "Assets/Icons/Curriculum/CompletedIcon.svg";
import { ReactComponent as ClassBg } from "Assets/Icons/Curriculum/ClassBg.svg";
import { ReactComponent as ForwardIcon } from "Assets/Icons/Curriculum/ForwardIcon.svg";
import { ReactComponent as LockIcon } from "Assets/Icons/Home/LockIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import { useNavigate, useParams } from "react-router-dom";

const styles = (theme) => ({
  border: `1px solid ${theme.palette.border.blue}`,
  borderRadius: "8px",
  padding: "16px",
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  "& .interviewStepsRoot": {
    "&>div": {
      border: `1px solid ${theme.palette.border.blue}`,
      borderRadius: "8px",
      padding: "16px",
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      gap: "16px",
    },
    "& .active": {
      background: theme.palette.primary.main,
      color: theme.palette.white.main,
    },
  },
  "& .borderSvg": {
    background: theme.palette.white.main,
    border: `2px solid ${theme.palette.border.blue}`,
    borderRadius: "50px",
    padding: "8px 4px",
  },
  "& .classStatus": {
    background: theme.palette.background.default,
    padding: "16px",
    borderRadius: "8px",
  },
});

const ModuleInterviewDetail = () => {
  const [currentStep, setCurrentStep] = useState(1);

  const navigate = useNavigate();
  const { id } = useParams();

  const interviewSteps = [
    {
      icon: CompletedIcon,
      label: "STEP-01",
      desc: "Attend all classes",
      step: 1,
      color: "success",
    },
    {
      icon: ForwardIcon,
      label: "STEP-02",
      desc: "Skill Test",
      step: 2,
      color: "primary",
    },
    {
      icon: LockIcon,
      label: "STEP-03",
      desc: "Schedule Expert Interview",
      step: 3,
      color: "secondary",
    },
    {
      icon: LockIcon,
      label: "STEP-04",
      desc: "Interview Results",
      step: 4,
      color: "secondary",
    },
  ];

  return (
    <Grid2 sx={styles}>
      <Box>
        <Typography>EXPERT MOCK INTERVIEW - 2</Typography>
        <Typography
          mt="5px"
          mb="15px"
          display={"flex"}
          fontWeight={500}
          variant="subtitle"
        >
          SQL
        </Typography>
        <Divider />
      </Box>
      <Box>
        <Typography fontWeight={500} variant="subtitle">
          Process of Expert Mock Interview
        </Typography>
        <Grid2 mt="10px" className="interviewStepsRoot" container spacing={2}>
          {interviewSteps?.map((item, i) => {
            return (
              <Grid2
                className={`${currentStep == item.step ? "active" : ""}`}
                key={i}
                onClick={() => setCurrentStep(item?.step)}
                size={3}
              >
                <PrimaryIcon
                  icon={item?.icon}
                  height="12px"
                  color={item?.color}
                  className="borderSvg"
                />
                <Box>
                  <Typography variant="subtitle" fontWeight={500}>
                    {item?.label}
                  </Typography>
                  <Typography>Schedule Expert Interview</Typography>
                </Box>
              </Grid2>
            );
          })}
        </Grid2>
      </Box>
      {currentStep == "1" ? (
        <>
          <Box display={"flex"} alignItems={"center"} gap="5px">
            <PrimaryIcon
              className="borderSvg"
              icon={CompletedIcon}
              height="12px"
              color="success"
            />
            <Typography variant="subtitle"> Step 1 : </Typography>
            <Typography variant="subtitle" fontWeight={500}>
              {" "}
              Attend all classes
            </Typography>
          </Box>
          <Box className="classStatus">
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Typography variant="subtitle" fontWeight={500}>
                Current Class
              </Typography>
              <Typography color="success" variant="subtitle">
                Classes Completed
              </Typography>
            </Box>
            <Box
              mt="16px"
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Box display={"flex"} alignItems={"center"} gap="10px">
                <PrimaryIcon
                  height="60px"
                  width="60px"
                  icon={ClassBg}
                  fill={false}
                />
                <Box display={"flex"} flexDirection={"column"} gap="5px">
                  <Typography>All classes completed</Typography>
                  <Typography color="secondary.light" variant="body2">
                    You can now schedule the Mandatory Expert Mock Interview
                  </Typography>
                </Box>
              </Box>
              <Button
                onClick={() => navigate(`/core-curriculum/${id}/classes`)}
                variant="outlined"
                color="secondary"
              >
                View All Classes
              </Button>
            </Box>
          </Box>
        </>
      ) : currentStep == "2" ? (
        <>
          <Box display={"flex"} alignItems={"center"} gap="5px">
            <PrimaryIcon
              className="borderSvg"
              icon={ForwardIcon}
              height="12px"
              color="primary"
            />
            <Typography variant="subtitle"> Step 2 : </Typography>
            <Typography variant="subtitle" fontWeight={500}>
              {" "}
              Skill Test
            </Typography>
          </Box>
          <Box
            sx={(theme) => ({
              border: `1px solid ${theme.palette.border.blue}`,
              borderRadius: "8px",
              padding: "16px",
            })}
          >
            <Typography mb="10px" color="secondary.light">
              MANDATORY SKILL TEST
            </Typography>
            <Box
              display={"flex"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Box>
                <Typography>
                  SQL Mandatory Skill Test &nbsp;
                  <Chip
                    color="yellow"
                    variant="outlined"
                    outlined
                    label="Pending"
                  ></Chip>{" "}
                </Typography>
                <Typography color="secondary.light">
                  Please Note: Clearing this skill test is mandatory for
                  attaining careers hub eligibility
                </Typography>
              </Box>
              <Button
                onClick={() => navigate(`/test/${id}`)}
                variant="contained"
              >
                Start Test
              </Button>
            </Box>
          </Box>
        </>
      ) : currentStep == "3" ? (
        <>
          <Box display={"flex"} alignItems={"center"} gap="5px">
            <PrimaryIcon className="borderSvg" icon={LockIcon} height="12px" />
            <Typography variant="subtitle"> Step 3 : </Typography>
            <Typography variant="subtitle" fontWeight={500}>
              {" "}
              Schedule Expert Interview
            </Typography>
          </Box>
          <Box
            sx={(theme) => ({
              border: `1px solid ${theme.palette.border.blue}`,
              borderRadius: "8px",
              padding: "16px",
            })}
          >
            <Typography
              sx={(theme) => ({
                background: theme.palette.background.default,
                padding: "8px",
                borderRadius: "8px",
              })}
              mb="10px"
              color="secondary.light"
            >
              Clearing Mock Interview will help you in securing job
              opportunities
            </Typography>
            <Typography mb="10px" color="secondary.light">
              Expert Mock Interview
            </Typography>
            <Box
              display={"flex"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Box>
                <Typography>
                  Agenda: SQL &nbsp;
                  <Chip
                    color="error"
                    variant="outlined"
                    outlined
                    label="Expired"
                  ></Chip>{" "}
                </Typography>
              </Box>
              <Box display={"flex"} alignItems={"center"} gap="10px">
                <Typography color="error">Interview expired</Typography>
                <Button variant="contained" color="error">
                  Schedule Additional Interview
                </Button>
              </Box>
            </Box>
            <Typography
              sx={(theme) => ({
                background: theme.palette.border.grey,
                borderRadius: "8px",
                padding: "8px",
              })}
              mt="10px"
              color="secondary.light"
            >
              Take the Mock Interview to get access to Career Hub and boost your
              job prospects with real interview questions and personalised
              feedback
            </Typography>
          </Box>
        </>
      ) : (
        <>
          <Box display={"flex"} alignItems={"center"} gap="5px">
            <PrimaryIcon
              className="borderSvg"
              icon={CompletedIcon}
              height="12px"
              color="success"
            />
            <Typography variant="subtitle"> Step 4 : </Typography>
            <Typography variant="subtitle" fontWeight={500}>
              {" "}
              Interview Results
            </Typography>
          </Box>
          <Box
            sx={(theme) => ({
              border: `1px solid ${theme.palette.border.blue}`,
              borderRadius: "8px",
              padding: "16px",
            })}
          >
            <Typography variant="subtitle" fontWeight={500}>
              Current Class
            </Typography>
            <Box
              mt="16px"
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Box display={"flex"} alignItems={"center"} gap="10px">
                <PrimaryIcon
                  height="60px"
                  width="60px"
                  icon={ClassBg}
                  fill={false}
                />
                <Typography color="secondary.light" variant="body2">
                  Once you complete your Expert Mock Interview feedback will
                  appear here. Please go through the details of how feedback
                  will be shared with you and explore career's hub
                </Typography>
              </Box>
              <Button variant="outlined" color="secondary">
                View Career Hub
              </Button>
            </Box>
          </Box>
        </>
      )}
    </Grid2>
  );
};

export default ModuleInterviewDetail;
